"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const app_1 = require("@hexelate/app");
const platformAPI_1 = require("./platformAPI");
(0, app_1.init)(new platformAPI_1.BrowserPlatformAPI());
